import { withDefault } from '@weft/utils';
import React from 'react';
import { useLightInvoices } from '../../../../hooks/requests/use-get-light-invoices';
import { useValidatedParams } from '../../../../hooks/use-validated-params';
import { LightInvoiceViewPageActionsMenu } from '../../LightInvoiceViewPage/light-invoice-view-page-components/LightInvoiceViewPageActionsMenu';

export const CustomerInvoicePageTabsAction: React.FC = () => {
  const { invoiceId } = useValidatedParams<['invoiceId']>('invoiceId');

  const { data: invoicesData } = useLightInvoices([invoiceId]);
  const [invoice] = withDefault(invoicesData?.invoices, []);

  return (
    <div className="flex gap-x-2 items-end ml-auto">
      <LightInvoiceViewPageActionsMenu
        invoiceId={invoiceId}
        invoice={invoice}
      />
    </div>
  );
};